import algoliasearch from "algoliasearch";

export const ALGOLIA_FOOD_ITEMS_INDEX_ALPHA_REPLICA =
  "kaboodle_fooditems_name_asc";

export const algoliaClient = algoliasearch(
  process.env.REACT_APP_ALGOLIA_APP_ID,
  process.env.REACT_APP_ALGOLIA_API_KEY
);
